import {
  LOAD_PERMISSIONS,
  SET_PERMISSIONS,
  FETCH_PERMISSIONS,
  RECEIVED_PERMISSIONS,
  ERROR_FETCH_PERMISSIONS
} from './types';
import { apiAction } from '../api/actions';

export function loadPermissions(session) {
  return {
    type: LOAD_PERMISSIONS,
    payload: session
  };
}

export function fetchPermissions() {
  // /auth/permissions returns { role, permissions: [permissionId, ...] }
  // for the *current* user. /su/permissions returns the admin matrix
  // ({ roles: {...}, permissions: { id: { admin: true, ... } } }) which
  // is what the admin page needs but not what this hook does. Hitting the
  // admin endpoint here used to silently work because
  // setEnabledPermissions([]) was the only branch that ever ran (session
  // bootstrap had no user.id), so the wrong shape was stored to
  // localStorage but never read back and reduced.
  return apiAction({
    resource: '/auth/permissions',
    onSuccess: (data) => broadcastReceivedPermissions(data),
    onFailure: onFetchPermissionsError,
    carry: {
      label: FETCH_PERMISSIONS
    }
  });
}

function broadcastReceivedPermissions(data) {
  // Normalise to the array shape the middleware/reducer expect. If the
  // server payload ever drifts (or a stale cached response is replayed),
  // we don't want to plant `{ role, permissions: [...] }` into the slot
  // that downstream `.reduce` calls treat as an array.
  const permissions = Array.isArray(data?.permissions) ? data.permissions : [];
  return {
    type: RECEIVED_PERMISSIONS,
    payload: {
      permissions
    }
  };
}

function onFetchPermissionsError(error) {
  return {
    type: ERROR_FETCH_PERMISSIONS,
    error
  };
}

export function setEnabledPermissions(permissionIds) {
  return {
    type: SET_PERMISSIONS,
    payload: {
      data: permissionIds || []
    }
  };
}
